module.exports = __webpack_public_path__ + "static/parade-2019-house18-ad0bbc703c32d5ddc1b31a843584bfcc.jpg";